module.exports = __webpack_public_path__ + "img/frasle-logo.cc45d463.jpg";